import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "nav-m" }
const _hoisted_2 = { class: "container nav-ul" }
const _hoisted_3 = ["onClick"]

import { Nav } from "@/types/nav";
import { ref } from "vue";
import menuBar from "../menu/index.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const menuBarRef = ref(null);
const active = "0";
const nav: Array<Nav> = [
  {
    value: "主页",
    link: "./#/",
    outside: true,
    icon: "",
    type: "normal",
    list: [],
  },
  {
    value: "",
    icon: "",
    link: "",
    outside: false,
    type: "logo",
    list: [],
  },
  {
    value: "投稿说明",
    link: "./#/Article?ArticleID=345601",
    outside: false,
    type: "normal",
    icon: "",
    list: [],
  },
];

function openMenu() {
  console.log(menuBarRef);

  if (menuBarRef.value && menuBarRef.value.openMenu) {
    menuBarRef.value.openMenu();
  } else {
    console.error(
      "menuBarRef is not defined or openMenu method is not available"
    );
  }
}
function navigate(item: Nav) {
  location.href = item.link;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "layout-top" }, [
      _createElementVNode("div", {
        class: "btn-menu",
        onClick: openMenu
      })
    ]),
    _createVNode(menuBar, {
      ref_key: "menuBarRef",
      ref: menuBarRef
    }, null, 512),
    _createElementVNode("div", {
      class: "nav-logo",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate(nav[1])))
    }),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(nav, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (item.type == 'normal')
            ? (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "item"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["nav-link", [active ? '' : 'active']]),
                  onClick: ($event: any) => (navigate(item))
                }, _toDisplayString(item.value), 11, _hoisted_3)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 64))
    ])
  ]))
}
}

})